<!-- #productbtn (mouseenter)="dropdown=true" (mouseleave)="hideDropdown($event)" -->
<ion-content>
  <div class="flex flex-col pl-24 pr-24 pb-16">
   <div class="w-100 ion-text-start mt-16" *ngFor="let item of listData" (click)="onClickItem(item)">
     <ion-text  [ngClass]="(selectedFilter && selectedFilter.id === item.id) ? 'lbl-sec-bold-14':'lbl-14'">{{item.name | getLanguagePipe}}</ion-text></div>
  </div>
  <div class="pl-24 pr-24 pb-16">
  <ion-text class="lbl-14" (click)="selectUnselectItem()">{{(isSelectAll === 1 ? unsellbl:sellbl) | getLanguagePipe}}</ion-text>
  </div>
</ion-content>